import React from 'react'
import PropTypes from 'prop-types'
import exact from 'prop-types-exact'
import { pure } from 'recompose'
import { Helmet } from 'react-helmet'
import { IMAGE_PATH, isProduction, normalizeSeoDescription } from 'config'
import { buildSiteUrl } from 'utils'

const propTypes = {
  canonicalUrlPath: PropTypes.string,
  description: PropTypes.string,
  metaTitle: PropTypes.string.isRequired,
}

export function clientCanonicalUrl(location = window.location) {
  const path = location.pathname.replace(/\/+$/, '') || '/'
  return `${location.origin}${path}`
}

function SiteMetadata({
  canonicalUrlPath,
  description,
  metaTitle,
}) {
  const url = canonicalUrlPath
    ? buildSiteUrl(canonicalUrlPath)
    : clientCanonicalUrl()
  const resolvedDescription = normalizeSeoDescription(description)

  return (
    <Helmet defer={false}>
      <title>{metaTitle}</title>
      {isProduction() && (
        <script
          type="text/javascript"
          src="//cdn-4.convertexperiments.com/v1/js/10041340-10041380.js"
        />
      )}

      <meta name="description" content={resolvedDescription} />
      <link rel="canonical" href={url} />

      {/* OpenGraph Metadata */}
      <meta property="og:title" content={metaTitle} />
      <meta property="og:description" content={resolvedDescription} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={IMAGE_PATH.SEATOW_LOGO} />
      <meta property="og:type" content="website" />
      <meta property="og:locale" content="en_US" />
    </Helmet>
  )
}

SiteMetadata.propTypes = exact(propTypes)

export default pure(SiteMetadata)
